import { render, staticRenderFns } from "./uploadAlerts.vue?vue&type=template&id=cd7a0e62&lang=html&"
import script from "./uploadAlerts.vue?vue&type=script&lang=js&"
export * from "./uploadAlerts.vue?vue&type=script&lang=js&"
import style0 from "./uploadAlerts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../rubis-bi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports